<div class="py-4 container-fluid teach-compensation-details-page teach-compensation-preview-page">
  <h4 class="mb-4 teach-compensation-details-title">
    การจัดการคำขอสอนชดเชย - คำขอสอนชดเชย
  </h4>

  <div class="teach-compensation-details-card teach-compensation-user-card">
    <div class="teach-compensation-user-info">
      <div
        *ngIf="hasAcademicTermPreview()"
        class="d-flex flex-wrap column-gap-4"
        aria-label="เทอมและปีการศึกษาของคำขอสอนชดเชย"
      >
        <span>
          <strong>เทอมการศึกษา :</strong>
          {{ academicTermName() }}
        </span>
        <span>
          <strong>ปีการศึกษา :</strong>
          {{ academicYear() }}
        </span>
      </div>
      <div>
        <strong>ชื่อ - นามสกุล :</strong>
        {{ teacherName() }}
      </div>
      <div>
        <strong>สาขาวิชา :</strong>
        {{ departmentName() }}
      </div>
    </div>

    <div class="teach-compensation-timetable-scroll">
      <table class="teach-compensation-timetable">
        <thead>
          <tr>
            <th class="teach-compensation-timetable-day-header">วัน - เวลา</th>
            <th
              *ngFor="let hour of timetableHours"
              class="teach-compensation-timetable-time-header"
              [attr.colspan]="hour.colSpan"
            >
              {{ hour.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of timetableRows()">
            <th class="teach-compensation-timetable-day-cell">
              <span>{{ row.thaiName }}</span>
              <span>{{ row.englishName }}</span>
            </th>
            <td
              *ngFor="let cell of row.cells"
              class="teach-compensation-timetable-cell"
              [class.teach-compensation-timetable-cell-filled]="cell.events.length > 0"
              [attr.colspan]="cell.colSpan"
            >
              <div
                *ngFor="let event of cell.events"
                class="teach-compensation-timetable-event"
                [attr.data-subject-name]="event.subjectName"
                [attr.aria-label]="event.subjectName"
              >
                <strong>{{ event.subjectLabel }}</strong>
                <span *ngIf="event.detailLabel">{{ event.detailLabel }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="teach-compensation-details-card">
    <div class="teach-compensation-details-form">
      <h5 class="teach-compensation-section-title">ข้อมูลคำขอสอนชดเชย</h5>

      <div class="teach-compensation-form-layout" style="width: 815px; max-width: 100%;">
        <div
          *ngFor="let row of previewRows()"
          class="row teach-compensation-form-row"
          style="margin-bottom: 30px;"
        >
          <div
            *ngFor="let field of row"
            class="teach-compensation-form-col"
            [ngClass]="field.columnClass ?? (row.length === 2 ? 'col-sm-6' : 'col-sm')"
          >
            <div class="teach-compensation-field">
              <div class="teach-compensation-label">
                {{ field.label }}
                <span *ngIf="field.required">*</span>
              </div>
              <div class="form-control teach-compensation-input teach-compensation-preview-value">
                {{ field.value }}
              </div>
            </div>
          </div>

          <div
            *ngIf="row.length === 2 && !row[0].columnClass"
            class="col-sm teach-compensation-form-col"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
